"use client"

import React from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import MainSection from "@/views/home/MainSection";
import FinanceTypesSection from "@/components/sections/FinanceTypesSection";
import RentSection from "@/components/sections/RentSection";
import FooterSection from "@/components/shared/FooterSection";
import AdvantagesSection from "@/components/sections/AdvantagesSection";
import NewsletterSection from "@/components/sections/NewsletterSection";
import SeoCatalogOffersSection from "@/components/sections/SeoCatalogOffersSection";
import BusinessProfileSection from "@/components/sections/BusinessProfileSection";
import { HomeStyle } from "@/styles/Home.style";
import FilterProvider from "@/providers/FilterProvider";
import HomeOffers from "@/views/home/HomeOffers";
import EducationSection from "@/components/sections/EducationSection";

const HomeTemplate = ({ offers }) => {
  return (
    <FilterProvider>
      <Wrapper>
        <HomeStyle />
        <MainSection />
        <HomeOffers offers={offers} />
        <FinanceTypesSection />
        <EducationSection />
        <RentSection />
        <FooterSection marginTop="0">
          <AdvantagesSection />
          <NewsletterSection />
          {/*<ArticlesSection data={posts} buttonLink="/blog" />*/}
          <SeoCatalogOffersSection />
          <BusinessProfileSection />
        </FooterSection>
      </Wrapper>
    </FilterProvider>
  );
};

export default HomeTemplate;

const Wrapper = styled(Box)`
  margin-top: -${({ theme }) => theme.space.XXL};

  @media (max-width: 800px){
    margin-top: -${({ theme }) => theme.space.XL};
  }
`;
